<template>
  <div
    class="header-container"
    :class="checkThemeRole"
  >
    <div class="uk-flex uk-flex-between">
      <div class="uk-width-auto">
        <a
          style="margin-top: 5px"
          class="header-link"
          @click.prevent="$emit('toggle-sidebar')"
        >
          <span uk-navbar-toggle-icon />
        </a>
      </div>
      <div class="uk-grid uk-grid-small">
        <div class="upc-navbar">
          <span class="upc-navbar-label">UPC Terakhir</span>
          <span class="upc-navbar-value">{{ latestUpcDateText }}</span>
        </div>
        <div class="notification-header">
          <div @click="handleUpdateNotificationList">
            <div class="notification-bell">
              <img
                :src="`${images}/icon/ic_bell.svg`"
                class="icon-notif"
                alt=""
              >
              <div
                v-if="total_unreads_message > 0"
                class="notification-dot"
              >
                {{
                  total_unreads_message > 99
                    ? "99+"
                    : total_unreads_message || "0"
                }}
              </div>
            </div>
          </div>

          <div
            uk-dropdown="mode: click;"
            class="dropdown-menu-notif"
          >
            <div
              v-if="notificationList?.isLoading"
              class="uk-padding uk-text-center text-primary"
            >
              <div uk-spinner />
            </div>

            <div
              v-if="
                !notificationList?.isLoading &&
                  notificationList?.data
              "
            >
              <ul
                class="uk-nav-default uk-nav-parent-icon"
                uk-nav
              >
                <li
                  v-for="(item, index) in notificationList
                    ?.data?.data"
                  :key="index"
                  class="notification-card-list"
                >
                  <a
                    class="uk-dropdown-close"
                    href="#"
                    @click.prevent="
                      handleUpdateNotificationRead(
                        item?.id,
                      )
                    "
                  >
                    <div class="notification-card">
                      <div class="notification-title">
                        {{ item?.fcm?.title || "-" }}
                      </div>
                      <div class="notification-sender">
                        Oleh - {{ item.sender || "" }}
                      </div>
                      <div class="notification-time">
                        {{
                          item.updated_at
                            ? formatRelativeTime(
                              item.updated_at,
                            ) || "-"
                            : "-"
                        }}
                      </div>
                    </div>
                  </a>
                </li>

                <li class="notification-more-list">
                  <router-link
                    class="uk-flex uk-flex-between uk-flex-middle uk-dropdown-close"
                    to="/admin/log-activity"
                  >
                    <div class="notification-see-more">
                      Lihat semua ({{
                        notificationList.data?.other
                          ?.total_unopens != 0
                          ? formatCurrencyDigit(
                            notificationList.data
                              ?.other
                              ?.total_unopens,
                          )
                          : "0" || "0"
                      }})
                    </div>
                    <div>
                      <img
                        :src="`${images}/icon/ic_arrow_right.svg`"
                        class="icon-arrow"
                        alt="icon_arrow"
                        loading="lazy"
                      >
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="profile-notif">
          <a
            class="header-link"
            href="#"
          >
            <img
              :src="
                user?.photo == ''
                  ? `${images}/avatar.png`
                  : user?.photo
              "
              alt="avatar.png"
              class="avatar-img"
            >
            <div class="user-profile">
              <span class="username uk-margin-small-left">{{
                user?.name || "Admin"
              }}</span>
              <span class="user-role uk-margin-small-left">{{
                user.role?.name || "Super Admin"
              }}</span>
            </div>
          </a>
          <div
            uk-dropdown="mode: click;"
            class="dropdown-menu"
          >
            <ul
              class="uk-nav-default uk-nav-parent-icon"
              uk-nav
            >
              <li class="profil-popup list-popup uk-nav-header">
                <router-link
                  style="
                                        text-decoration: none;
                                        padding: 0 24px;
                                    "
                  class="uk-dropdown-close"
                  to="/"
                >
                  <span class="profile-wrapper">
                    <div class="dropdown-profile">
                      <span
                        class="dropdown-name uk-margin-small-left"
                      >{{
                        user.name || "Admin"
                      }}</span>
                      <span
                        class="dropdown-status uk-margin-small-left"
                      >{{
                        user.role?.name ||
                          "Super Admin"
                      }}</span>
                      <span
                        class="dropdown-email uk-margin-small-left"
                      >{{ user.email || "-" }}</span>
                    </div>
                    <img
                      :src="`${images}/avatar.png`"
                      alt=""
                      class="profil-img"
                    >
                  </span>
                </router-link>
              </li>
              <li class="log-activity-popup list-popup">
                <router-link
                  style="
                                        text-decoration: none;
                                        padding: 0 24px;
                                    "
                  class="change-btn uk-dropdown-close"
                  to="/admin/log-activity"
                >
                  <span class="title-popup-wrapper">
                    <img
                      :src="`${images}/icon/ic_log_activity.svg`"
                      style="margin: 17px 0"
                      class="uk-margin-small-right"
                    >
                    Log Aktivitas
                  </span>
                </router-link>
              </li>
              <li class="change-pass-popup list-popup">
                <router-link
                  style="
                                        text-decoration: none;
                                        padding: 0 24px;
                                    "
                  class="change-btn uk-dropdown-close"
                  to="/admin/change-password"
                >
                  <span class="title-popup-wrapper">
                    <img
                      :src="`${images}/icon/ic_lock.svg`"
                      style="margin: 17px 0"
                      class="uk-margin-small-right"
                    >
                    Ganti Password
                  </span>
                </router-link>
              </li>
              <li
                class="logout-popup list-popup"
                @click="logout()"
              >
                <a
                  href="#"
                  style="
                                        text-decoration: none;
                                        padding: 0 24px;
                                    "
                  class="logout-btn"
                >
                  <span>
                    <img
                      :src="`${images}/icon/ic_logout.svg`"
                      style="margin: 17px 0"
                      class="uk-margin-small-right"
                    >
                    Keluar
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import "firebase/compat/messaging"
import { appFirebase } from "@/configs/firebase"
// import firebase from 'firebase/compat/app'
import { getMessaging, onMessage } from "firebase/messaging"
import { notificationDanger } from "@/utils/notification"
import {
  dateHeaderString,
  dateRelativeTime,
  currencyDigit,
  dateShortMonthWithTime
} from "@/utils/formater"
import { PREFIX_IMAGE } from "@/utils/constant"
import { getUserProfile } from "@/utils/auth"

export default {
  props: {
    roleType: {
      required: true,
      type: String
    }
  },
  emits: ["toggle-sidebar"],
  data() {
    return {
      images: PREFIX_IMAGE,
      profile: {},
      total_unreads_message: 0
    }
  },
  computed: {
    ...mapGetters({
      notificationList: "notification/get_notification_list",
      latestUpcDate: "dashboard/get_latest_upc_date"
    }),
    latestUpcDateText() {
      return dateShortMonthWithTime(this.latestUpcDate) || '-'
    },
    user() {
      return getUserProfile()
    },
    checkThemeRole() {
      switch (this.roleType) {
      case "SUPER ADMIN" ||
                    "ADMIN GENERAL" ||
                    "ADMIN FINANCE" ||
                    "ADMIN KLAIM" ||
                    "ADMIN KEPESERTAAN":
        return "bg-admin"
      case "COMPANY":
        return "bg-company"
      case "USER":
        return "bg-employee"
      default:
        return ""
      }
    }
  },
  watch: {
    notificationList(val) {
      if (!val?.isLoading && val?.data) {
        this.total_unreads_message = val?.data?.other?.total_unreads
      }
    }
  },
  created() {
    if (!("Notification" in window)) {
      // Check if the browser supports notifications //
      notificationDanger(
        "This browser does not support desktop notification"
      )
    } else {
      Notification.requestPermission().then((permission) => {
        if (permission !== "granted") {
          notificationDanger("Please allow notifications")
        }
        return permission
      })
    }
  },
  async mounted() {
    this.getLatestUpcDate()
    await this.actionGetNotificationList({ limit: 5, sort_by: "desc" })
    const messaging = getMessaging(appFirebase)
    onMessage(messaging, () => {
      this.total_unreads_message += 1
    })
  },
  methods: {
    ...mapActions({
      actionGetNotificationList: "notification/getNotificationList",
      updateNotificationList: "notification/updateNotificationList",
      getLatestUpcDate: "dashboard/getLatestUpcDate"
    }),
    async logout() {
      await this.$store.dispatch("auth/logout")
    },
    getDateHeader() {
      return dateHeaderString(new Date())
    },
    formatRelativeTime(date) {
      return dateRelativeTime(date)
    },
    formatCurrencyDigit(data) {
      return currencyDigit(data)
    },
    handleUpdateNotificationList() {
      this.updateNotificationList({ status: "OPEN" })
        .then((result) => {
          if (
            result?.status === 200 ||
                        result?.message == "success"
          ) {
            setTimeout(() => {
              this.actionGetNotificationList({
                limit: 5,
                sort_by: "desc"
              })
            }, 500)
          }
        })
        .catch((error) => {
          notificationDanger(
            error?.response?.data?.message || "Notification Error"
          )
        })
    },
    handleUpdateNotificationRead(id) {
      this.updateNotificationList({ id: id, status: "READ" })
        .then((result) => {
          if (
            result?.status === 200 ||
                        result?.message == "success"
          ) {
            this.$router.push({
              name: "LogActivity",
              query: { id: id }
            })
          }
        })
        .catch((error) => {
          notificationDanger(
            error?.response?.data?.message || "Notification Error"
          )
        })
    }
  }
}
</script>

<style scoped>
.header-container {
    padding: 0 1.5rem;
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}
.bg-admin {
    background-color: #d5ddf6;
}
.bg-company {
    background-color: #fad6da;
}
.bg-employee {
    background-color: #ffe7a3;
}
.header-link {
    color: #1f242e;
    text-decoration: none;
    align-items: center;
    min-height: 50px;
    display: flex;
}
.header-link:hover {
    color: #1f242e;
}
.text-primary {
    color: #004fa4;
}
.text-right {
    display: grid;
    justify-content: end;
}
.text-center {
    display: grid;
    justify-content: center;
}
.user-profile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.username {
    font-weight: bold;
    font-size: 14px;
    color: #1f242e;
    text-transform: capitalize;
}
.user-role {
    font-style: 500;
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    color: #8592ad;
    text-transform: capitalize;
}
.profil-popup {
    text-transform: capitalize;
}
.profil-popup:hover {
    background: #d7e1ed;
    cursor: pointer;
}
.profile-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e0ebe6;
}
.dropdown-profile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.dropdown-name {
    font-family: Poppins;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 150%;
    color: #181d25;
    margin-top: 16px;
    margin-left: 0 !important;
}
.dropdown-status {
    font-family: Poppins;
    font-style: 400;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #1f2e28;
    margin: 4px 0 !important;
}
.dropdown-email {
    text-transform: lowercase;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
    color: #004fa4;
    margin-bottom: 16px;
    margin-left: 0 !important;
}
.profil-img {
    width: 56px;
    max-width: 56px;
    height: 56px;
    max-height: 56px;
    margin-left: 16px;
    border-radius: 40px;
}
.avatar-img {
    width: 33px;
    max-width: 33px;
    height: 33px;
    max-height: 33px;
    margin-left: 8px;
    border-radius: 40px;
}
.dropdown-menu {
    width: 320px;
    left: unset !important;
    right: 24px !important;
    padding: 0;
    border-radius: 0px 0px 16px 16px;
    margin-top: 0;
    background: #ffffff;
    box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
}
.profile-notif {
    display: flex;
    align-items: center;
    padding-left: 0px;
}
.list-popup {
    padding: 0;
}
.change-btn {
    height: 58px;
    display: flex;
    align-items: center;
    font-family: "Poppins";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
}
.change-btn:hover {
    cursor: pointer;
    background: #d7e1ed;
    color: #f0f3f5;
    opacity: 1;
}
.title-popup-wrapper {
    width: 100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #063a79;
    border-bottom: 1px solid #f0f3f5;
}
.logout-btn {
    height: 58px;
    display: flex;
    align-items: center;
    font-family: Poppins;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: #cf212a;
}
.logout-btn:hover {
    cursor: pointer;
    background: rgba(249, 38, 38, 0.08);
    border-radius: 0px 0px 16px 16px;
    color: #cf212a;
    opacity: 1;
}
.upc-navbar {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    padding: 6px 12px;
    line-height: 1.3;
    margin-right: 4px;
}
.upc-navbar-label {
    font-family: 'Poppins';
    font-size: 11px;
    color: #8592ad;
    white-space: nowrap;
}
.upc-navbar-value {
    font-family: 'Poppins';
    font-size: 13px;
    font-weight: 600;
    color: #1f242e;
    white-space: nowrap;
}
.notification-header {
    display: flex;
    align-items: center;
    margin-right: 10px;
    padding-left: 0px;
}
.notification-bell {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
}
.notification-dot {
    position: absolute;
    min-width: 15px;
    min-height: 15px;
    padding: 0px 4px;
    font-family: "PoppinsBold";
    font-size: 10px;
    font-weight: 700;
    line-height: 1.7;
    color: #ffffff;
    top: 0px;
    right: 0px;
    background-color: #eb1c24;
    text-align: center;
    border-radius: 18px;
}
.icon-notif {
    width: 23px;
    height: 23px;
}
.dropdown-menu-notif {
    width: 320px;
    max-width: calc(100vw - 16px);
    padding: 0px;
    background: #ffffff;
    left: unset !important;
    right: 60px !important;
    border-radius: 0px 0px 16px 16px;
    box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
}
@media screen and (max-width: 480px) {
    .dropdown-menu-notif {
        right: 0 !important;
        width: calc(100vw - 16px);
    }
    .dropdown-menu {
        right: 0 !important;
        width: calc(100vw - 16px);
    }
    .upc-navbar {
        display: none !important;
    }
    .user-profile {
        display: none !important;
    }
}
.notification-card-list a {
    padding: 0px;
}
.notification-card-list:hover {
    background-color: #fff2a88c;
}
.notification-card-list.unread {
    background-color: #fff2a88c;
}
.notification-card {
    width: 100%;
    padding: 10px 25px 12px 25px;
    border-bottom: 1.2px solid #f3f3f3;
}
.notification-title {
    margin-bottom: 3px;
    font-family: "PoppinsMedium";
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
    color: #004fa4;
}
.notification-sender {
    margin-bottom: 5px;
    font-family: "Poppins";
    font-size: 15px;
    font-weight: 400;
    color: #1f2e28;
}
.notification-time {
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 400;
    color: #8cbffe;
}
.notification-more-list {
    padding: 15px 25px;
}
.notification-more-list a {
    padding: 0px;
}
.notification-see-more {
    font-family: "Poppins";
    font-size: 16px;
    font-weight: 400;
    color: #063a79;
}
</style>
